import { transfer } from 'comlink';
import { isComlinkProxy } from '../helpers/comlinkHelpers';
const LOG_PREFIX = '[Track]';
export class Track {
    trackId;
    local;
    listener;
    transferLoggedOnce = false;
    buffer = [];
    isProcessing = false;
    constructor(trackId, isLocal) {
        this.trackId = trackId;
        this.local = isLocal;
    }
    getTrackId() {
        return Promise.resolve(this.trackId);
    }
    isLocal() {
        return Promise.resolve(this.local);
    }
    setListener(listener) {
        this.listener = listener;
        // Start processing if there are buffered items
        if (this.buffer.length > 0) {
            void this.processBuffer();
        }
    }
    unsetListener() {
        this.listener = undefined;
    }
    /**
     * Add a frame to the buffer and start async processing.
     * Returns the current buffer length.
     */
    emit(frame, done, transferSet = []) {
        this.buffer.push({ frame, done, transferSet });
        void this.processBuffer();
        return this.buffer.length;
    }
    /**
     * Process buffered items one-by-one, awaiting each listener call.
     */
    async processBuffer() {
        // Prevent concurrent processing
        if (this.isProcessing || !this.listener) {
            return;
        }
        this.isProcessing = true;
        const isProxyListener = isComlinkProxy(this.listener);
        try {
            while (this.buffer.length > 0 && this.listener) {
                const item = this.buffer.shift();
                if (!item) {
                    continue;
                }
                if (isProxyListener && item.frame !== undefined) {
                    // Log once per track to avoid spam
                    if (!this.transferLoggedOnce) {
                        console.log(`${LOG_PREFIX} using transfer for proxy listener`, {
                            trackId: this.trackId,
                            transferableCount: item.transferSet.length,
                        });
                        this.transferLoggedOnce = true;
                    }
                    await this.listener(transfer(item.frame, item.transferSet), item.done);
                }
                else {
                    await this.listener(item.frame, item.done);
                }
            }
        }
        finally {
            this.isProcessing = false;
        }
    }
    hasListener() {
        return this.listener !== undefined;
    }
    getBufferLength() {
        return this.buffer.length;
    }
}
